export * from './src';
import {TimeSlotCalendar} from './src';

export default TimeSlotCalendar;


/** WEBPACK FOOTER **
 ** ./client/shared/packages/TimeSlotCalendar/index.js
 **/